<template>
    <div :style="{'background-color': netState == 0 ? '#f5f5f5' : '#ffffff'}">
      <loadStateView :state="netState" :refreshHandle="refreshData"/>
      <div class="sortMenuDiv" v-if="leagueType == 1 && netState == 0" :style="{top: getTopWithNavBarHeight(45)}">
        <div class="sortMenu">
            <div class="btnList">
                <div class="btn" v-for="(item, index) in sortMenu" :key="index" @click="handleSortMenu(index)" v-bind:class=" selectedIndex==index ? 'selBackground' : 'btn' " :style="drawBtnListLine(index)">
                {{item}}
                </div>
            </div>
        </div>
      </div>
        <!-- 球队信息 -->
        <div class="teamHead" v-if="netState == 0" :style="{top: getTopWithNavBarHeight(leagueType == 1 ? 85 : 45)}">
            <span class="teamName">{{ $t("players.teamName") }}</span>
            <span class="matchCount">{{ $t("oddsStatistics.matchCount") }}</span>
            <span class="hasOdds">{{ $t("oddsStatistics.hasOdds") }}</span>
            <span class="hasOdds">{{ $t("oddsStatistics.han") }}</span>
            <span class="winAndLoss">{{ $t("oddsStatistics.winAndLoss") }}</span>
            <span class="goalDifference">{{ $t("oddsStatistics.goalDifference") }}</span>
            <span class="winningRate">{{ $t("oddsStatistics.winningRate") }}</span>
        </div>
        <div v-for="(team, index) in teamList[selectedIndex]" :key="index">
            <div class="teamCell">
                <span class="teamName" @click="clickTeamName(team.teamId)">{{team.team}}</span>
                <span class="matchCount">{{team.matchNum}}</span>
                <span class="hasOdds">{{team.opening}}</span>
                <span class="hasOdds">{{team.onMarket}}</span>
                <span class="winAndLoss">{{team.winNum}}/{{team.drawNum}}/{{team.loseNum}}</span>
                <span class="goalDifference">{{team.netWin}}</span>
                <span class="winningRate">{{team.winRate}}</span>
            </div>
            <div class="line"></div>
        </div>
        <!-- 联赛盘路数据统计 -->
        <div class="dataStatisticsBG" v-if="leagueType == 1 && netState == 0">
          <div class="dataStatisticsTitle"><span>{{ $t("oddsStatistics.dataStatistics") }}</span></div>
            <div class="line"></div>
            <div class="dataStatistics">
              <div class="divStatistics">
                <div>
                  <span class="fontSize24">{{stat.homeWinRate}}</span>
                  <span class="fontSize10">%</span>
                </div>
                <div class="divWinCount">
                  <span class="fontSize12">{{ $t("oddsStatistics.homeWin") }}</span>
                  <span class="fontSize16">{{stat.homeWin}}</span>
                  <span class="fontSize10">{{ $t("oddsStatistics.site") }}</span>
                </div>
              </div>
              <div class="line2"></div>
              <div class="divStatistics">
                <div>
                  <span class="fontSize24">{{stat.drawRate}}</span>
                  <span class="fontSize10">%</span>
                </div>
                <div class="divWinCount">
                  <span class="fontSize12">{{ $t("oddsStatistics.draw") }}</span>
                  <span class="fontSize16">{{stat.draw}}</span>
                  <span class="fontSize10">{{ $t("oddsStatistics.site") }}</span>
                </div>
              </div>
              <div class="line2"></div>
              <div class="divStatistics">
                <div>
                  <span class="fontSize24">{{stat.awayWinRate}}</span>
                  <span class="fontSize10">%</span>
                </div>
                <div class="divWinCount">
                  <span class="fontSize12">{{ $t("oddsStatistics.guestWin") }}</span>
                  <span class="fontSize16">{{stat.awayWin}}</span>
                  <span class="fontSize10">{{ $t("oddsStatistics.site") }}</span>
                </div>
              </div>
            </div>
        </div>
        <!-- 杯赛盘路数据统计 -->
        <div class="dataStatisticsBG" v-if="leagueType == 2 && netState == 0">
          <div class="dataStatisticsTitle"><span>{{ $t("oddsStatistics.dataStatistics") }}</span></div>
            <div class="line"></div>
            <div class="dataStatistics">
              <div class="divStatistics">
                <div>
                  <span class="fontSize24">{{stat.winRate}}</span>
                  <span class="fontSize10">%</span>
                </div>
                <div class="divWinCount">
                  <span class="fontSize12">{{ $t("oddsStatistics.btnWin") }}</span>
                  <span class="fontSize16">{{stat.win}}</span>
                  <span class="fontSize10">{{ $t("oddsStatistics.site") }}</span>
                </div>
              </div>
              <div class="line2"></div>
              <div class="divStatistics">
                <div>
                  <span class="fontSize24">{{stat.drawRate}}</span>
                  <span class="fontSize10">%</span>
                </div>
                <div class="divWinCount">
                  <span class="fontSize12">{{ $t("oddsStatistics.draw") }}</span>
                  <span class="fontSize16">{{stat.draw}}</span>
                  <span class="fontSize10">{{ $t("oddsStatistics.site") }}</span>
                </div>
              </div>
            </div>
        </div>
        <!-- 赢盘之最 -->
        <div class="dataStatisticsBG" v-if="netState == 0">
          <div class="winMostTitle">
            <span class="title">{{ $t("oddsStatistics.winMost") }}</span>
            <div class="winSortMenu">
              <div class="winBtnList">
                  <div class="btn" v-for="(item, index) in winMostMenu" :key="index" @click="handleWinMostMenu(index)" v-bind:class=" selectedMostIndex==index ? 'selBackground' : 'btn' ">
                  {{item}}
                  </div>
              </div>
            </div>
          </div>
          <div class="line"></div>
        </div>
        <div class="divWinMost" v-if="netState == 0">
          <div v-for="(data, index) in winMostList[selectedMostIndex]" :key="index">
            <div class="winMostCell">
              <div class="teamNameList">
                <span class="teamNameCell" v-for="(teamName, row) in data.teamNames" :key="row" :style="{'margin-top': row > 0 ? '7px' : '0px'}">
                  {{teamName}}
                  <br v-if="row < data.teamNames.length - 1">
                </span>
              </div>
              <div class="rate">
                <span class="fontSize12">{{ $t("oddsStatistics.winRate") }}</span>
                <span class="rateText">{{data.rate}}</span>
                <span class="fontSize10">%</span>
              </div>
              <div :class="index == 0 ? 'most' : 'least'"></div>
            </div>
            <div class="line"></div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  activated () {
    if (this.$route.params.yearForRoute && this.$route.params.yearForRoute.length > 0) {
      this.year = this.$route.params.yearForRoute
    } else {
      this.loadData()
    }
  },
  watch: {
    year (newValue) {
      if (newValue.length > 0) {
        this.loadDataWithYear()
      } else {
        this.loadData()
      }
    }
  },
  props: {
    yearForRoute: {
      type: Object,
      default () {
        return {}
      }
    },
    leagueTypeForRoute: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    loadData: function () {
      this.netState = this.winMostList.length > 0 ? 0 : 1
      this.$ft_getHistoryOdds(this.$route.params.leagueId).then(result => {
        this.computedData(result)
      }).catch((error) => {
        this.netState = this.winMostList.length > 0 ? 0 : 2
        console.log('error:', error)
      })
    },
    loadDataWithYear: function () {
      this.netState = this.winMostList.length > 0 ? 0 : 1
      this.$ft_getOddsByYear(this.$route.params.leagueId, this.year).then(result => {
        this.computedData(result)
      }).catch((error) => {
        this.netState = this.winMostList.length > 0 ? 0 : 2
        console.log('error:', error)
      })
    },
    refreshData: function () {
      if (this.year.length > 0) {
        this.loadDataWithYear()
      } else {
        this.loadData()
      }
    },
    computedData: function (result) {
      if (result['allMatches'] && result['allMatches'].length === 0) {
        this.netState = 3
        return
      }
      this.leagueType = this.$route.params.leagueTypeForRoute
      this.configMenu()

      var teamList = []
      teamList.push(result.allMatches)
      teamList.push(result.homeMatches)
      teamList.push(result.awayMatches)
      this.teamList = teamList
      this.stat = result.stat

      var winMost = [{ teamNames: this.stat.winMostTeam.split(','), rate: this.stat.winMostRate }, { teamNames: this.stat.winLeastTeam.split(','), rate: this.stat.winLeastRate }]
      var drawMost = [{ teamNames: this.stat.drawMostTeam.split(','), rate: this.stat.drawMostRate }]
      var winMostList = []
      winMostList.push(winMost)
      if (this.leagueType === 1) {
        var homeWinMost = [{ teamNames: this.stat.homeWinMostTeam.split(','), rate: this.stat.homeWinMostRate }, { teamNames: this.stat.homeWinLeastTeam.split(','), rate: this.stat.homeWinLeastRate }]
        var awayWinMost = [{ teamNames: this.stat.awayWinMostTeam.split(','), rate: this.stat.awayWinMostRate }, { teamNames: this.stat.awayWinLeastTeam.split(','), rate: this.stat.awayWinLeastRate }]
        winMostList.push(homeWinMost)
        winMostList.push(awayWinMost)
      }
      winMostList.push(drawMost)
      this.winMostList = winMostList
      this.netState = this.winMostList.length > 0 ? 0 : result.netState
    },
    configMenu: function () {
      if (this.leagueType === 1) {
        this.winMostMenu = [
          this.$t('oddsStatistics.btnWin'),
          this.$t('oddsStatistics.homeCourt'),
          this.$t('oddsStatistics.guestCourt'),
          this.$t('oddsStatistics.btnDraw')
        ]
      } else {
        this.winMostMenu = [
          this.$t('oddsStatistics.btnWin'),
          this.$t('oddsStatistics.btnDraw')
        ]
      }
    },
    handleSortMenu: function (index) {
      this.selectedIndex = index
    },
    handleWinMostMenu: function (index) {
      this.selectedMostIndex = index
    },
    drawBtnListLine: function (index) {
      if (index === 0) {
        return { 'border-left-style': 'none' }
      } else {
        return { 'border-left-style': 'solid', 'border-left-width': '1px', 'border-left-color': '#06b782' }
      }
    },
    clickTeamName: function (teamId) {
      this.$router.push({ name: 'football-team-schedule', params: { teamId: teamId.toString() } })
    },
    getTopWithNavBarHeight: function (top) {
      return (top + parseInt(this.$route.params.NavBarHeight)) + 'px'
    }
  },
  data () {
    return {
      sortMenu: [
        this.$t('oddsStatistics.totalCourt'),
        this.$t('oddsStatistics.homeCourt'),
        this.$t('oddsStatistics.guestCourt')
      ],
      winMostMenu: [],
      selectedIndex: 0,
      selectedMostIndex: 0,
      teamList: [[]],
      stat: {}, // 统计数据
      winMostList: [],
      year: this.yearForRoute,
      leagueType: this.leagueTypeForRoute, // 1联赛 2杯赛
      netState: 0
    }
  }
}
</script>

<style lang="sass" scoped>
@import "style"
</style>
